import _ from "lodash";

export default {
  // 作業船IDの配列を取得する
  getEquipmentVesselIds: (state, _getters, _rootState, rootGetters) => {
    const addonFlag = rootGetters.getAddonFlag("GKMG_BASE_STATION");
    // addonがfalseの場合空配列を返す
    if (!addonFlag) return [];
    return state.equipmentVessels.map((v) => v.vessel_id);
  },
  /** 投入実績をソートして返す */
  getEquipmentTypes: (state) => {
    if (!state.equipmentTypes || !state.equipmentTypes.length) {
      return [];
    }
    // idの昇順
    return _.orderBy(state.equipmentTypes, "id", "asc");
  },
  /** 拠点情報をソートして返す */
  getSortedBaseStations: (state) => {
    if (!state.equipmentBaseStations || !state.equipmentBaseStations.length) {
      return [];
    }
    // idの昇順
    return _.orderBy(state.equipmentBaseStations, "id", "asc");
  },
  /** 運搬航路をソートして返す */
  getSortedSeaRoutes: (state) => (vessel) => {
    if (!state.equipmentSeaRoutes || !state.equipmentSeaRoutes.length) {
      return [];
    }
    if (
      !state.equipmentDepartureWharfs ||
      !state.equipmentDepartureWharfs.length
    ) {
      return [];
    }
    if (!state.equipmentDestinations || !state.equipmentDestinations.length) {
      return [];
    }
    if (
      !vessel ||
      !vessel.data ||
      !vessel.data.gkmg_equipment_departure_wharf_id ||
      !vessel.data.gkmg_equipment_destination_id
    ) {
      return [];
    }
    // 出発岸壁を取得
    const targetDepartureWharf = state.equipmentDepartureWharfs.find(
      (wharf) => {
        return wharf.id === vessel.data.gkmg_equipment_departure_wharf_id;
      },
    );
    if (!targetDepartureWharf || !targetDepartureWharf.point) {
      return [];
    }
    // 目的地を取得
    const targetDestination = state.equipmentDestinations.find(
      (destination) => {
        return destination.id === vessel.data.gkmg_equipment_destination_id;
      },
    );
    if (!targetDestination || !targetDestination.point) {
      return [];
    }
    // [INFO] 出発岸壁IDから経由地を取得する
    const foundData = state.equipmentSeaRoutes.find((seaRoute) => {
      return (
        seaRoute.gkmg_equipment_departure_wharf_id ===
          vessel.data.gkmg_equipment_departure_wharf_id &&
        seaRoute.gkmg_equipment_destination_id ===
          vessel.data.gkmg_equipment_destination_id
      );
    });
    if (!foundData || !foundData.data) {
      return [];
    }
    // 経由地を並び替える
    const sortedSeaRoute = _.orderBy(foundData.data, "sort_order", "asc");
    // 出発岸壁、目的地を含む全航路
    const allSeaRoute = [
      targetDepartureWharf,
      ...sortedSeaRoute,
      targetDestination,
    ];
    // 必要な座標だけ取得する
    return allSeaRoute.map((seaRoute) => {
      return [seaRoute.point.latitude, seaRoute.point.longitude];
    });
  },
};
